(() => {
  const STORAGE_KEY_DESKTOP = 'kt-collection-grid-cols';
  const STORAGE_KEY_MOBILE = 'kt-collection-grid-cols-mobile';
  const MOBILE_QUERY = '(max-width: 767px)';

  const readStorage = (key, fallback) => {
    try {
      return window.localStorage.getItem(key) || fallback;
    } catch (error) {
      return fallback;
    }
  };

  const writeStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* ignore quota / private mode */
    }
  };

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const getDesktopCols = () => (readStorage(STORAGE_KEY_DESKTOP, '3') === '2' ? '2' : '3');
  const getMobileCols = () => (readStorage(STORAGE_KEY_MOBILE, '1') === '2' ? '2' : '1');

  const applyLayout = () => {
    const desktopCols = getDesktopCols();
    const mobileCols = getMobileCols();
    const grid = document.getElementById('main-collection-product-grid');

    if (grid) {
      grid.classList.remove(
        'kt-collection-grid-cols-2',
        'kt-collection-grid-cols-3',
        'kt-collection-grid-cols-mobile-1',
        'kt-collection-grid-cols-mobile-2',
      );
      grid.classList.add(`kt-collection-grid-cols-${desktopCols}`);
      grid.classList.add(`kt-collection-grid-cols-mobile-${mobileCols}`);
    }

    const activeCols = isMobile() ? mobileCols : desktopCols;

    document.querySelectorAll('[data-collection-grid-cols]').forEach((button) => {
      const active = button.getAttribute('data-collection-grid-cols') === activeCols;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  /* The visible label mirrors the invisible native select on top of it. */
  const updateSortLabel = () => {
    const select = document.querySelector('[data-collection-sort-select]');
    const label = document.querySelector('[data-collection-sort-label]');
    if (!select || !label) return;

    const option = select.options[select.selectedIndex];
    if (option) label.textContent = option.textContent;
  };

  const onSortChange = (event) => {
    const select = event.target.closest('[data-collection-sort-select]');
    if (!select) return;

    /* Keep the other sort fields (filter drawer) on the same value. */
    document.querySelectorAll('[name="sort_by"]').forEach((input) => {
      if (input !== select) input.value = select.value;
    });
    updateSortLabel();
  };

  const onToolbarClick = (event) => {
    const layoutButton = event.target.closest('[data-collection-grid-cols]');
    if (!layoutButton) return;

    event.preventDefault();
    const cols = layoutButton.getAttribute('data-collection-grid-cols');

    if (isMobile()) {
      if (cols === '1' || cols === '2') {
        writeStorage(STORAGE_KEY_MOBILE, cols);
      }
    } else if (cols === '2' || cols === '3') {
      writeStorage(STORAGE_KEY_DESKTOP, cols);
    }

    applyLayout();
  };

  const onGridFiltered = () => {
    applyLayout();
    updateSortLabel();
  };

  if (!window.ktCollectionToolbarBound) {
    window.ktCollectionToolbarBound = true;
    document.addEventListener('click', onToolbarClick);
    document.addEventListener('change', onSortChange);
    document.addEventListener('krown:main-collection-grid:filtered', onGridFiltered);
    window.matchMedia(MOBILE_QUERY).addEventListener('change', applyLayout);
  }

  applyLayout();
  updateSortLabel();
})();
